import axios from '../../_services/axios';

export default {
  state: {
    status: '',
    roles: [],
    user: {},
  },
  getters: {
    roles: state => state.roles,
    isAdmin: state => state.user.role === 'Admin',
    id: state => state.user.id,
  },
  mutations: {
    roles_request(state) {
      state.status = 'loading';
    },
    roles_success(state, result) {
      state.status = 'success';
      state.roles = result.roles;
    },
    roles_error(state) {
      state.status = 'error';
    },
    user_request(state) {
      state.status = 'loading';
    },
    user_success(state, result) {
      state.status = 'success';
      state.user = result.user;
    },
    user_error(state) {
      state.status = 'error';
    },
    logout(state) {
      state.status = '';
      state.roles = [];
      state.user = {};
    },
  },
  actions: {
    roles({ commit }) {
      return new Promise((resolve, reject) => {
        commit('roles_request');

        axios
          .get('users/roles')
          .then(resp => {
            const roles = resp.data;
            commit('roles_success', { roles });
            resolve(resp);
          })
          .catch(err => {
            commit('roles_error');
            reject(err);
          });
      });
    },
    user({ dispatch, commit }, username) {
      return new Promise((resolve, reject) => {
        commit('user_request');

        axios
          .get(`users?username=${username}`)
          .then(resp => {
            const user = resp.data;
            commit('user_success', { user });

            dispatch('roles').then(() => {
              resolve(resp);
            });
          })
          .catch(err => {
            commit('user_error');
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise(resolve => {
        commit('logout');
        resolve();
      });
    },
  },
};
